import { vPagesUsersService } from "../../services/vfPages/";
import { useWebsitesStore } from "../../store/websitesStore";
import React, { useState, useEffect } from "react";
import SearchBar from "../common/search";
import { ActionsButtons } from "../common/actionsButton";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { dictionary } from "../../utils/dictionary";
import { membershipAxios } from "../../services/membership/MembershipAxios";
import { CreditsBadge } from "../ui/badge/CreditBadge";
import SwitchTabs from "../home/SwitchTabs";
import { Tooltip } from "../utils/Tooltip/Tooltip";
import { dataFake } from "../onboarding1/dataFake/dataFake";

interface WebsitesHeaderProps {
  handleTypeSection: (type: string) => void;
  typeSection: string;
}

const WebsitesHeader: React.FC<WebsitesHeaderProps> = ({ handleTypeSection, typeSection }) => {
  const { language, credits, setCredits } = useAuth();
  const navigate = useNavigate();
  const { projectActive } = useWebsitesStore();
  const [projectId, setProjectId] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const projectId = await projectActive();
      setProjectId(projectId);
    })();
  }, []);

  const setCreditsToContext = async () => {
    try {
      const membership = await membershipAxios();
      setCredits(membership.credits || 0);
    } catch (error: any) {
      console.error("Error fetching membership:", error);
      if (error.response?.data.trigger === "NOT_ACTIVE_MEMBERSHIP") {
        navigate("/plans");
      }
    }
  };

  setCreditsToContext();

  const createWebsite = async () => {
    // const uuidDataFake = decodeTokenService.getUserIdFromToken();
    // if (dataFake[uuidDataFake as keyof typeof dataFake] !== undefined) {
    //   navigate(`/onboarding1?uuidData=${uuidDataFake}`);
    // } else {
      navigate("/onboarding");
    // }
  };

  const createHome = async () => {
    navigate("/onboarding/home");
  };

  const isOnboardingDisabled = import.meta.env.VITE_DISABLED_ONBOARDING === "true";

  return (
    <div className="mb-6 mt-8">
      <div className="md:hidden">
        <div className="mt-[30px]"></div>
      </div>
      <div className="flex items-center justify-between mb-4">
        <div>
          <SwitchTabs label={typeSection} onClick={(type) => handleTypeSection(type)} />
        </div>

        <div className="flex items-center space-x-3">
          <CreditsBadge amount={credits} label={dictionary["credits"][language]} />

          {typeSection === dictionary["funnels-label"][language] && (
            isOnboardingDisabled ? (
              <Tooltip content={dictionary["problems-with-the-creation-of-pages-and-images"]?.[language] ?? "La opción de crear está deshabilitada"}>
                <div className="inline-flex">
                  <ActionsButtons
                    actionClick={createWebsite}
                    mainButtonColor="bg-gradient-to-r from-[#5050EA] to-[#85A2FF] px-4 py-2 text-white rounded-lg flex items-center space-x-2"
                    mainButtonLabel={dictionary["create-funnel"][language]}
                    disabled={isOnboardingDisabled}
                  />
                </div>
              </Tooltip>
            ) : (
              <ActionsButtons
                actionClick={createWebsite}
                mainButtonColor="bg-gradient-to-r from-[#5050EA] to-[#85A2FF] px-4 py-2 text-white rounded-lg flex items-center space-x-2"
                mainButtonLabel={dictionary["create-funnel"]?.[language] ?? "Crear embudo"}
                disabled={isOnboardingDisabled}
              />
            )
          )}

          {typeSection === dictionary["homes-label"][language] && (
            isOnboardingDisabled ? (
              <Tooltip content={dictionary["problems-with-the-creation-of-pages-and-images"]?.[language] ?? "La opción de crear está deshabilitada"}>
                <div className="inline-flex">
                  <ActionsButtons
                    actionClick={createHome}
                    mainButtonColor="bg-gradient-to-r from-[#5050EA] to-[#85A2FF] px-4 py-2 text-white rounded-lg flex items-center space-x-2"
                    mainButtonLabel={dictionary["create-home"]?.[language] ?? "Crear tienda"}
                    disabled={isOnboardingDisabled}
                  />
                </div>
              </Tooltip>
            ) : (
              <ActionsButtons
                actionClick={createHome}
                mainButtonColor="bg-gradient-to-r from-[#5050EA] to-[#85A2FF] px-4 py-2 text-white rounded-lg flex items-center space-x-2"
                mainButtonLabel={dictionary["create-home"][language]}
                disabled={isOnboardingDisabled}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default WebsitesHeader;
